import React from "react";
import PrivacyPolicyComponent from "../../components/PrivacyComponent/PrivacyComponent.jsx";
import Support from "../../components/SuportComponent/support.js";

function PrivacyPolicyPage() {
  return (
    <div>
      <PrivacyPolicyComponent />
      <Support />
    </div>
  );
}

export default PrivacyPolicyPage;
